var demandsService = function () {
  this.getDemandsByObject = function (projectUid, objectId) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demands/project/${projectUid}/object/${objectId}`, {
        method: "GET",
        headers: {
          // "session_token": AuthenticationService.getUser() && AuthenticationService.getUser().session_token,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.post = function (model) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demands`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "project_uid": model.project_uid,
          "title": model.title,
          "goal": model.goal,
          "workflow_origin": model.workflow_origin,
          "owner_uid": model.owner_uid,
          "object_id": model.object_id,
          "composition_uid": model.composition_uid
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.put = function (id, model) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demand/` + id, {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "title": model.title,
          "goal": model.goal
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.delete = function (id) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demand/` + id, {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  return this;
}

var DemandsService = new demandsService();

export {
  DemandsService
};